<template>
  <div>
    <gmap-map
      :center="center"
      :zoom="13"
      style="width:100%;  height: calc(100vh - 103px)"
    >
      <gmap-marker
        class="ts-bg-green-600 ts-text-blue-600"
        v-for="(marker, index) in allMarker"
        :key="index"
        :position="marker"
        :icon="{
          url: showMarker(marker.type)
        }"
        @click="onClickMarker(marker)"
      >
      </gmap-marker>
    </gmap-map>
    <a-modal
      v-if="show"
      v-model="show"
      :title="$t('visitation.viewMap')"
      centered
      :zIndex="1020"
      :footer="null"
      :maskClosable="false"
      width="300px"
    >
      <label class="ts-w-full">
        Card #:
        <span class="ts-text-blue-600">{{
          markerData.sale ? markerData.sale.card_id : ''
        }}</span>
      </label>
      <label>
        Sale Name:
        <span class="ts-text-blue-600">{{
          markerData.sale ? markerData.sale.employee_name_en : ''
        }}</span>
      </label>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'viewMap',
  props: ['record'],
  data() {
    return {
      show: false,
      markerData: [],
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      marker_icon: require('@/assets/marker.png'),
      tso: require('@/assets/tso.png'),
      dso: require('@/assets/dso.png')
    }
  },
  created() {
    if (!_.isEmpty(this.record)) {
      var locat = this.record
      this.center = {
        lng: locat[0].gis_location.lng,
        lat: locat[0].gis_location.lat
      }
    }
  },
  computed: {
    showMarker: vm => type => {
      if (type < 11) {
        return require('@/assets/marker/' + type + '.svg')
      }
      return undefined
    },
    allMarker() {
      if (this.record) {
        const sale = [...new Set(this.record.map(obj => obj.created_by))]
        return this.record.map(el => ({
          lat: el.gis_location.lat,
          lng: el.gis_location.lng,
          type: sale.indexOf(el.created_by),
          data: el
        }))
      }
      return []
    }
  },
  methods: {
    onClickMarker(marker) {
      this.show = true
      this.markerData = marker.data
    }
  }
}
</script>
